export const dataProviderConfig = {
    loadBiddingApiDataProvider: 'https://bidding.spi3pl-tech.com/api/v1',
    authApiDataProvider: 'https://auth.spi3pl-tech.com/api/v1',
    permissionsDataProvider: 'https://auth.spi3pl-tech.com/api/v1',
}